import React, {useEffect, useState} from 'react';
import './groupSearcher.css';
import {FormattedMessage, useIntl} from "react-intl";
import auth from "../../../utils/authentication";
import {useDispatch, useSelector} from "react-redux";
import group, {GroupResults} from "../index";
import users from "../../users";
import {ogFunctions} from "../../../apis/og-functions/ogFunctionsApi";
import ButtonV2 from "../../shared/button-v2/button-v2";

function GroupSearcher() {
    const intl = useIntl();
    const dispatch = useDispatch();

    const [nameSearch, setNameSearch] = useState('');
    const currentSearch = useSelector(group.selectors.getGroupSearch);
    const darkTheme = useSelector(users.selectors.isDarkMode);

    useEffect(() => {
        if (currentSearch?.keywords) {
            setNameSearch(currentSearch.keywords);
        }
    }, [currentSearch])

    const makeSearch = async () => {
        if (currentSearch?.keywords !== nameSearch) {
            dispatch(group.actions.groupSearchCompleted({}));
            const data = {keywords: nameSearch, page: 0};
            const searchGroups = ogFunctions.httpsCallable('findGroupsByKeywords');
            const res = await searchGroups(data);
            res.data.keywords = nameSearch;
            dispatch(group.actions.groupSearchCompleted(res.data));
        }
    }

    const controlKey = event => {
        if (event.key === "Enter" && nameSearch) {
            makeSearch();
        }
    }

    return (
        <div className="d-flex d-column justify-content-center flex-wrap myDrive__container" style={{
            overflowY: 'auto',
            maxHeight: "calc(90dvh - 95px)",
        }}>
            <div className="d-flex flex-column flex-wrap justify-content-center col-12">
                <div className="text-center">
                    <i className="fa-solid fa-people-line fa-2xl"></i>
                </div>
                <div className="col-12 mb-3">
                    <div className="form-floating col-12">
                        <input type="text" className="form-control col-12" id="searchInput" value={nameSearch}
                               placeholder={intl.formatMessage({id: "group-search.input-searcher"})}
                               onChange={e => setNameSearch(e.target.value)}
                               onKeyDown={e => {
                                   controlKey(e);
                               }}/>
                        <label htmlFor="searchInput"><FormattedMessage id="group-search.input-searcher"/></label>
                    </div>
                    <small><FormattedMessage id="group-search.input-searcher.text"/></small>
                </div>
                <div className="col-12 d-flex flex-wrap justify-content-center mt-3">
                    <ButtonV2 type="button"
                              disabled={!nameSearch || !auth.currentUser}
                              onClick={() => {
                                  if (auth.currentUser) {
                                      makeSearch();
                                  }
                              }}>
                        <FormattedMessage id="app.search"/>&nbsp;
                        <i className="fa-solid fa-magnifying-glass"></i>
                    </ButtonV2>
                </div>
            </div>
            {currentSearch &&
                <GroupResults hideTitle={true}/>
            }
        </div>
    );

}

export default GroupSearcher;
